export interface IResetPassword{
  email: string;
}

export function emptyResetPassword(): IResetPassword{
  return {
    email: ""
  };
}